<template>
  <pt-save-sign-notes class="pt-save-sign-notes__page" :name="name" :id="id"></pt-save-sign-notes>
</template>

<script>
import PtSaveSignNotes from 'cps/appointment-application/pt-save-sign-notes/withData'
export default {
  name: 'pt-save-sign-notes__view',
  components: {
    'pt-save-sign-notes': PtSaveSignNotes
  },
  props: {
    name: {
      type: String
    },
    id: {
      type: String
    }
  }
}
</script>
